

//BUg : 
//after file selected, still show 'no file selected'
// Loop error


import React from 'react';
import Moment from 'react-moment';
import { Form, Field} from 'react-final-form';
import Modal from '../../widgets/Modal';
import Confirm from '../../widgets/Confirm';
import {connect} from 'react-redux';
import {CardHalfVertical} from '../../widgets/Cards';
import { fetchPhotoExternals, fetchPhotoExternal, editPhotoExternal, newPhotoExternal, deletePhotoExternal} from '../../../actions';
import { fetchPhotoDisplay} from '../../../actions';

class PhotoExternal extends React.Component {

    constructor(props) {
            super(props);
            this.state = {
                showModal: false,
                showDelete : false,
                newForm : true,
                record : null,
                category : "Skin",
                selectedFile :null,
                fileName :"",
                isFilePicked: false,
                blankPhoto: true,
            };

        this.handleFile = this.handleFile.bind(this);  
        this.handleChange = this.handleChange.bind(this); 
    };

    //Initial Rendering
    componentDidMount() {
        this.props.fetchPhotoExternals(this.props.patient._id);
    }

    //Update Rendering
    componentDidUpdate(prevProps) {
       
        if (this.props.photo_externals.length !== prevProps.photo_externals.length) {
            this.props.fetchPhotoExternals(this.props.patient._id);
        }
    }
      
    //Getting ID of the external Photo
    selectRow = (event) => {
        var ID = event.currentTarget.id;
        this.props.fetchPhotoExternal(ID);
        var filename = event.currentTarget.dataset.filename;
        this.props.fetchPhotoDisplay(filename);
        this.setState({blankPhoto: false});
    }

    //sorting list by date
    compareDate(a, b) {

        var key1 = a.datetaken;
        var key2 = b.datetaken;
    
        if (key1 > key2) {
            return -1;
        } else if (key1 === key2) {
            return 0;
        } else {
            return 1;
        }
    }

    // Render content
    renderPhotoExternalList() {
  
            var list = this.props.photo_externals;
            var sortedList = list.sort(this.compareDate);
    
            return sortedList.map(photo_external =>  {

            const rowButton = () => {
                var permit = this.props.selectedPermission.permission[0].chronicdisease;
                if (permit === "View only") {
                    return null;
                } else { 
                    return (
                        <>
                            <button onClick={() => this.setState({showModal: true, newForm: false, record: photo_external._id})} className='tableEdit'><i className="far fa-edit"></i></button>
                            <button onClick={() => this.setState({showDelete: true, record: photo_external._id})} className='tableDelete'><i className="fas fa-trash"></i></button>
                        </>
                    )
                }  
            }
            return (
                    <tr key={photo_external._id} id={photo_external._id} data-filename={photo_external.filename} onClick={this.selectRow}>
                        <td>{photo_external.caption}</td>
                        <td>{photo_external.location}</td>
                        <td>{photo_external.category}</td>
                        <td> <Moment format='DD MMM YYYY'>{photo_external.datetaken}</Moment></td>      
                        <td>
                            {rowButton()}
                        </td>
                    </tr>
            )
        })
    }

    buttons() {
        var permit = this.props.selectedPermission.permission[0].photo;
        if (permit === "View only") {
            return null
        } else { 
            return  <button onClick={() => this.setState({showModal: true, newForm: true, record: null})} style={{width:'96%', fontSize:'14px'}} className='btnew'>Add</button>
        }  
        
    }

    renderPhoto() { 
        var photo = this.state.blankPhoto;
        if (photo === true) {
            return <div>Click above list to display photo</div>
        }
        else {
            var imageData = this.props.showPhoto_Display;
            return <img src={imageData} alt="none" style={{height:"300px"}}/>
        }
    }

    render() {
        return (
                <CardHalfVertical title='External'>
                    {this.buttons()}
                    <div className="form-2-rows">
                        <div>
                        <table>
                            <thead>
                            <tr>
                                <th>Caption</th>
                                <th>Location</th>
                                <th>Category</th>
                                <th>Date</th>   
                                <th>Actions</th>
                            </tr>
                            </thead>
                            <tbody> 
                                {this.renderPhotoExternalList()}
                            </tbody> 
                        </table>
                        {this.renderModalBox()}
                        {this.renderDeleteBox()}
                        </div>
                        <div style={{ textAlign :"center"}}>
                            {this.renderPhoto()}
                        </div>
                    </div>
                </CardHalfVertical>
        )
    }

    //on change file button

    handleFile(event) {
		this.setState({
            selectedFile: event.target.files[0], 
            isFilePicked:true,
            fileName: event.target.files[0].name
         });
        
	};

    handleChange(event) {
        this.setState({category: event.target.value});
    }

    //Update or New Form Pop Up

    renderModalBox() {
        // const record = this.state.record;
        // if (record !== null) {
        //    this.props.fetchPhotoExternal(record);
        // }

        const photo_externalForm = (e) => {
            const required = value =>(value ? undefined : 'Required');


            //section to check if this new form or editing. If it's editing, get current content from the selectedPhoto_external state from redux shop
            //currentPhotoExternal to be used in the pre-filled form
            //for new form -> submit as formData. 
            //for editing -> submit as form (no file included)
            var content;
            if (this.state.newForm === false ) {
                content = this.props.selectedPhoto_External;
            } else {
                content = null;
            }
            const currentPhotoExternal = content;

            //section when form is ready to be submitted
            const handleSubmit = (formValues) => {
            
                const form = formValues;
                let formData = new FormData();

                formData.append('location', form.location);
                formData.append('category', form.category);
                formData.append('caption', form.caption);

                //only update this section if it's new form
                if (this.state.newForm === true ) {
                    var uploadedPhoto = this.state.selectedFile;
                    var newFileName = this.props.patient._id + "taken" + new Date().getTime();

                    formData.append("patientId", this.props.patient._id);
                    formData.append('practiceID', 5);
                    formData.append('externalID', 4);
                    formData.append('provider', "Dr findatu");
                    formData.append('filename', newFileName);
                    formData.append('photo', uploadedPhoto, newFileName);
                }

                const photo_externalId = form._id;
                //Section to check formData value
                for(let [name, value] of formData) {
                    console.log(`${name} = ${value}`); 
                    }

                if (photo_externalId === undefined) {
                    this.props.newPhotoExternal(formData);
                } else {
                    this.props.editPhotoExternal(form, photo_externalId);
                }
                this.setState({showModal :false, newForm : true,record : null,});
            }

            return (
                <Form 
                    onSubmit = {handleSubmit} 
                    initialValues = {currentPhotoExternal}
                    render = {({ handleSubmit, pristine, form, values, submitting }) => {
                    return   (
                            <form onSubmit={handleSubmit} encType="multipart/form-data">

                                    <Field name="caption" component='input' validate={required} placeholder=''>
                                        {({input, meta, placeholder}) => (
                                            <div className={meta.active ? 'active':''}>
                                                <label>Caption</label>
                                                <input {...input} placeholder={placeholder} />
                                                {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                            </div>
                                        )}
                                    </Field>
                                    <Field name="location" component='input' validate={required} placeholder=''>
                                        {({input, meta, placeholder}) => (
                                            <div className={meta.active ? 'active':''}>
                                                <label>Location</label>
                                                <input {...input} placeholder={placeholder} />
                                                {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                            </div>
                                        )}
                                    </Field>
                                    <Field name="category" component='input' value={this.state.category} onChange={this.handleChange}>
                                        {({ input}) => (
                                            <div>
                                                <label>Category</label>
                                                <select {...input}>
                                                    <option value="Skin">Skin</option>
                                                    <option value="Wound">Wound</option>
                                                    <option value="Nail">Nail</option>
                                                    <option value="Hair">Hair</option>
                                                    <option value="Other">Other</option>
                                                </select>
                                            </div>
                                        )}
                                    </Field>
                                    <Field name="photo" component='input' onChange={this.handleFile}>
                                        {({input, onChange}) => (
                                            <div>
                                                <label>Photo</label>
                                                <input {...input} type='file' accept="image/png, .jpeg, .jpg, image/gif" onChange={onChange}/>
                                            </div>
                                        )}
                                    </Field>

                                    <div className='modalButton'>
                                        <button type='submit' disabled={submitting || pristine} className='btnew'>Submit</button>
                                        <button type='button' onClick={form.reset} disabled={submitting || pristine } className='btdel'>Reset</button>
                                        <button onClick={() => this.setState({showModal: false, record: null})} className='btdel'>Cancel</button>
                                    </div>
                                  
                            </form>
                        )
                    }}
                />
            )
        }   
        //  <pre>{JSON.stringify(values, 0, 2)}</pre>

// main render

// SECTION D
        return (
            <Modal 
                height='300px'
                width='300px'
                open={this.state.showModal} 
                title='External'
                data={this.state.record}
                content={photo_externalForm()}
                onDismiss={() => this.setState({showModal: false, record: null})}
            />
        )
    }

    //Delete confirmation pop up
    renderDeleteBox() {

        const handleDelete = () => {
            this.props.deletePhotoExternal(this.state.record);
            this.setState({showDelete:false, record:null})
        }

        const deleteButtons = () => {
            return (
            <div>
                <button onClick={() => this.setState({showDelete: false})} className='btdel'>Cancel</button>
                <button onClick={handleDelete} className='btsave'>Ok</button>
            </div>
            )
        }

//SECTION E
        return (
            <Confirm
            height='100px'
            width='300px'
            open={this.state.showDelete} 
            data={this.state.record}
            content="Delete this External ?"
            title='Delete External'
            actions = {deleteButtons()}
            onDismiss={() => this.setState({showDelete : false, record:null})}
        />
        )
    }
}


const mapStateToProps = (state) => {
    return { 
        contents : state.selectedPatient,
        photo_externals : Object.values(state.photo_externals),
        selectedPhoto_External : state.selectedPhoto_External,
        showPhoto_Display : state.showPhoto_Display,
        patient : state.selectedPatient,
        userId : state.auth.userId,
        selectedPermission : state.selectedPermission,
    }
}

export default connect(mapStateToProps, {fetchPhotoDisplay, fetchPhotoExternals, fetchPhotoExternal, editPhotoExternal, newPhotoExternal, deletePhotoExternal})(PhotoExternal);



